"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Model_1 = require("../Model");
var AuditLog = /** @class */ (function () {
    function AuditLog() {
    }
    AuditLog.logShipmentById = function (shipmentId) {
        return Model_1.Model.makeRequest('/delivery/private/shipment-audit-log', Model_1.METHOD.POST, { shipmentId: shipmentId });
    };
    AuditLog.logShipmentByBarcode = function (barcode) {
        return Model_1.Model.makeRequest('/delivery/private/shipment-audit-log', Model_1.METHOD.POST, { barcode: barcode });
    };
    return AuditLog;
}());
exports.AuditLog = AuditLog;
